/**
 * The app's navigation, in one place.
 *
 * `Layout` renders this and `App` mounts a `<Route>` per entry, so the two
 * cannot disagree about what exists -- `routing.test.tsx` pins that.
 *
 * Four tabs: the things you use at or after a game. People is setup, so it
 * sits behind the header icon instead (mockup, 2026-09-10).
 */
export type NavIcon = "events" | "upcoming" | "stats" | "arenas";

export interface NavEntry {
  to: string;
  label: string;
  icon: NavIcon;
}

export const NAV: readonly NavEntry[] = [
  { to: "/", label: "Events", icon: "events" },
  { to: "/upcoming", label: "Upcoming", icon: "upcoming" },
  { to: "/stats", label: "Stats", icon: "stats" },
  { to: "/arenas", label: "Arenas", icon: "arenas" },
];
